export default __webpack_public_path__ + "static/media/resource-cluster.d690cdee.svg";